import { useSelector } from 'react-redux';
import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';

const PROJECT_ID = '9f5fdddb-a00a-4c46-90dd-549515db9661';
const FILTER_BY_FRESHNESS_ON = 'variant_CampaignFilter_on';
const FILTER_BY_FRESHNESS_OFF = 'control_CampaignFilter_off';

export const useFilterByFreshnessExperiment = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, PROJECT_ID));

    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === FILTER_BY_FRESHNESS_ON;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [FILTER_BY_FRESHNESS_ON, FILTER_BY_FRESHNESS_OFF],
});
